<template>
    <div class="d-block position-relative">
        <label  v-if="booking_type == 1">{{__('pages.when')}}</label>
        <label v-else>{{__('pages.when_from')}}</label>
        <div class="input">
            <date-range-picker
                    ref="picker"
                    :locale-data="{ firstDay: 1, format: 'yyyy.mm.dd' }"
                    v-model="when"
                    :opens="'center'"
                    :singleDatePicker="true"
                    :timePicker="false"
                    :timePicker24Hour="false"
                    :showWeekNumbers="false"
                    :showDropdowns="false"
                    :ranges="false"
                    :autoApply="true"
                    :alwaysShowCalendars="true"
                    :timePickerIncrement="60"
                    @update="updateValues"
                    :dateFormat="dateFormat"       
            >
            </date-range-picker>
        </div>
        <div class="invalid-feedback d-none" data-error-container="when_start"></div>
        <div v-if="booking_type != 1">
            <div class="input">
                <div class="position-relative">
                    <select  v-model="time_from">
                        <option value="00:00">00:00</option>
                        <option value="00:30">00:30</option>
                        <option value="01:00">01:00</option>
                        <option value="01:30">01:30</option>
                        <option value="02:00">02:00</option>
                        <option value="02:30">02:30</option>
                        <option value="03:00">03:00</option>
                        <option value="03:30">03:30</option>
                        <option value="04:00">04:00</option>
                        <option value="04:30">04:30</option>
                        <option value="05:00">05:00</option>
                        <option value="05:30">05:30</option>
                        <option value="06:00">06:00</option>
                        <option value="06:30">06:30</option>
                        <option value="07:00">07:00</option>
                        <option value="07:30">07:30</option>
                        <option value="08:00">08:00</option>
                        <option value="08:30">08:30</option>
                        <option value="09:00">09:00</option>
                        <option value="09:30">09:30</option>
                        <option value="10:00">10:00</option>
                        <option value="10:30">10:30</option>
                        <option value="11:00">11:00</option>
                        <option value="11:30">11:30</option>
                        <option value="12:00">12:00</option>
                        <option value="12:30">12:30</option>
                        <option value="13:00">13:00</option>
                        <option value="13:30">13:30</option>
                        <option value="14:00">14:00</option>
                        <option value="14:30">14:30</option>
                        <option value="15:00">15:00</option>
                        <option value="15:30">15:30</option>
                        <option value="16:00">16:00</option>
                        <option value="16:30">16:30</option>
                        <option value="17:00">17:00</option>
                        <option value="17:30">17:30</option>
                        <option value="18:00">18:00</option>
                        <option value="18:30">18:30</option>
                        <option value="19:00">19:00</option>
                        <option value="19:30">19:30</option>
                        <option value="20:00">20:00</option>
                        <option value="20:30">20:30</option>
                        <option value="21:00">21:00</option>
                        <option value="21:30">21:30</option>
                        <option value="22:00">22:00</option>
                        <option value="22:30">22:30</option>
                        <option value="23:00">23:00</option>
                        <option value="23:30">23:30</option>
                    </select>
                </div>
            </div>
            <div class="invalid-feedback d-none" data-error-container="time_from"></div>
        </div>
        <div v-if="booking_type == 1">
            <label>{{__('pages.time_from')}}</label>
            <div class="d-flex align-items-center justify-content-between">
                <div style="width:48%">
                    <div class="input">
                        <div class="position-relative">
                            <select  v-model="time_from">
                                <option value="00:00">00:00</option>
                                <option value="00:30">00:30</option>
                                <option value="01:00">01:00</option>
                                <option value="01:30">01:30</option>
                                <option value="02:00">02:00</option>
                                <option value="02:30">02:30</option>
                                <option value="03:00">03:00</option>
                                <option value="03:30">03:30</option>
                                <option value="04:00">04:00</option>
                                <option value="04:30">04:30</option>
                                <option value="05:00">05:00</option>
                                <option value="05:30">05:30</option>
                                <option value="06:00">06:00</option>
                                <option value="06:30">06:30</option>
                                <option value="07:00">07:00</option>
                                <option value="07:30">07:30</option>
                                <option value="08:00">08:00</option>
                                <option value="08:30">08:30</option>
                                <option value="09:00">09:00</option>
                                <option value="09:30">09:30</option>
                                <option value="10:00">10:00</option>
                                <option value="10:30">10:30</option>
                                <option value="11:00">11:00</option>
                                <option value="11:30">11:30</option>
                                <option value="12:00">12:00</option>
                                <option value="12:30">12:30</option>
                                <option value="13:00">13:00</option>
                                <option value="13:30">13:30</option>
                                <option value="14:00">14:00</option>
                                <option value="14:30">14:30</option>
                                <option value="15:00">15:00</option>
                                <option value="15:30">15:30</option>
                                <option value="16:00">16:00</option>
                                <option value="16:30">16:30</option>
                                <option value="17:00">17:00</option>
                                <option value="17:30">17:30</option>
                                <option value="18:00">18:00</option>
                                <option value="18:30">18:30</option>
                                <option value="19:00">19:00</option>
                                <option value="19:30">19:30</option>
                                <option value="20:00">20:00</option>
                                <option value="20:30">20:30</option>
                                <option value="21:00">21:00</option>
                                <option value="21:30">21:30</option>
                                <option value="22:00">22:00</option>
                                <option value="22:30">22:30</option>
                                <option value="23:00">23:00</option>
                                <option value="23:30">23:30</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div style="width:48%">
                    <div class="input">
                        <div class="position-relative">
                            <select id="booking-time-to" v-model="time_to">
                                <option value="00:00">00:00</option>
                                <option value="00:30">00:30</option>
                                <option value="01:00">01:00</option>
                                <option value="01:30">01:30</option>
                                <option value="02:00">02:00</option>
                                <option value="02:30">02:30</option>
                                <option value="03:00">03:00</option>
                                <option value="03:30">03:30</option>
                                <option value="04:00">04:00</option>
                                <option value="04:30">04:30</option>
                                <option value="05:00">05:00</option>
                                <option value="05:30">05:30</option>
                                <option value="06:00">06:00</option>
                                <option value="06:30">06:30</option>
                                <option value="07:00">07:00</option>
                                <option value="07:30">07:30</option>
                                <option value="08:00">08:00</option>
                                <option value="08:30">08:30</option>
                                <option value="09:00">09:00</option>
                                <option value="09:30">09:30</option>
                                <option value="10:00">10:00</option>
                                <option value="10:30">10:30</option>
                                <option value="11:00">11:00</option>
                                <option value="11:30">11:30</option>
                                <option value="12:00">12:00</option>
                                <option value="12:30">12:30</option>
                                <option value="13:00">13:00</option>
                                <option value="13:30">13:30</option>
                                <option value="14:00">14:00</option>
                                <option value="14:30">14:30</option>
                                <option value="15:00">15:00</option>
                                <option value="15:30">15:30</option>
                                <option value="16:00">16:00</option>
                                <option value="16:30">16:30</option>
                                <option value="17:00">17:00</option>
                                <option value="17:30">17:30</option>
                                <option value="18:00">18:00</option>
                                <option value="18:30">18:30</option>
                                <option value="19:00">19:00</option>
                                <option value="19:30">19:30</option>
                                <option value="20:00">20:00</option>
                                <option value="20:30">20:30</option>
                                <option value="21:00">21:00</option>
                                <option value="21:30">21:30</option>
                                <option value="22:00">22:00</option>
                                <option value="22:30">22:30</option>
                                <option value="23:00">23:00</option>
                                <option value="23:30">23:30</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="invalid-feedback d-none" data-error-container="time_to"></div>
        </div>
        <div v-else>
            <label>{{__('pages.when_to')}}</label>
            <div class="input">
                <date-range-picker
                        ref="picker"
                        :locale-data="{ firstDay: 1, format: 'yyyy.mm.dd' }"
                        v-model="when_to"
                        :opens="'center'"
                        :singleDatePicker="true"
                        :timePicker="false"
                        :timePicker24Hour="false"
                        :showWeekNumbers="false"
                        :showDropdowns="false"
                        :ranges="false"
                        :autoApply="true"
                        :alwaysShowCalendars="true"
                        :timePickerIncrement="60"
                        @update="updateToValues"
                        :dateFormat="dateFormat"       
                >
                </date-range-picker>
            </div>
            <div class="invalid-feedback d-none" data-error-container="when_to"></div>
            <div v-if="booking_type != 1">
                <div class="input">
                    <div class="position-relative">
                        <select  v-model="time_to">
                            <option value="00:00">00:00</option>
                            <option value="00:30">00:30</option>
                            <option value="01:00">01:00</option>
                            <option value="01:30">01:30</option>
                            <option value="02:00">02:00</option>
                            <option value="02:30">02:30</option>
                            <option value="03:00">03:00</option>
                            <option value="03:30">03:30</option>
                            <option value="04:00">04:00</option>
                            <option value="04:30">04:30</option>
                            <option value="05:00">05:00</option>
                            <option value="05:30">05:30</option>
                            <option value="06:00">06:00</option>
                            <option value="06:30">06:30</option>
                            <option value="07:00">07:00</option>
                            <option value="07:30">07:30</option>
                            <option value="08:00">08:00</option>
                            <option value="08:30">08:30</option>
                            <option value="09:00">09:00</option>
                            <option value="09:30">09:30</option>
                            <option value="10:00">10:00</option>
                            <option value="10:30">10:30</option>
                            <option value="11:00">11:00</option>
                            <option value="11:30">11:30</option>
                            <option value="12:00">12:00</option>
                            <option value="12:30">12:30</option>
                            <option value="13:00">13:00</option>
                            <option value="13:30">13:30</option>
                            <option value="14:00">14:00</option>
                            <option value="14:30">14:30</option>
                            <option value="15:00">15:00</option>
                            <option value="15:30">15:30</option>
                            <option value="16:00">16:00</option>
                            <option value="16:30">16:30</option>
                            <option value="17:00">17:00</option>
                            <option value="17:30">17:30</option>
                            <option value="18:00">18:00</option>
                            <option value="18:30">18:30</option>
                            <option value="19:00">19:00</option>
                            <option value="19:30">19:30</option>
                            <option value="20:00">20:00</option>
                            <option value="20:30">20:30</option>
                            <option value="21:00">21:00</option>
                            <option value="21:30">21:30</option>
                            <option value="22:00">22:00</option>
                            <option value="22:30">22:30</option>
                            <option value="23:00">23:00</option>
                            <option value="23:30">23:30</option>
                        </select>
                    </div>
                </div>
                <div class="invalid-feedback d-none" data-error-container="time_to"></div>
            </div>
        </div>
        <div class="input">
            <div class="position-relative">
                <textarea id="booking-comment" v-model="comment"></textarea>
            </div>
        </div>
        <div class="invalid-feedback d-none" data-error-container="comment"></div>
        <div class="button">
            <button type="button" class="btn btn-orange w-100 h-100" v-on:click="submit()" :title="__('pages.search')">{{__('pages.online_booking_submit')}}</button>
        </div>
    </div>
</template>
<script>
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
    data(){
        return {
            minDate: '',
            when: {startDate:this.getDate(), endDate: null},
            when_to: {startDate:this.getDate(), endDate: null},
            time_to: '10:00',
            time_from: '12:00',
            comment: '',
            booking_type: 2,
            property_id: 0
        };
    },
    created(){
        if(this.params){
            this.when = {startDate: this.params.when_start ? this.params.when_start : this.getDate(), endDate: null};
            this.when_to = {startDate: this.params.when_end ? this.params.when_end : this.getDate(), endDate: null};
            this.time_to = this.params.time_to ? this.params.time_to : '12:00';
            this.time_from = this.params.time_from ? this.params.time_from : '10:00';
            this.property_id = this.params.property_id ? this.params.property_id : '';
            this.booking_type = this.params.booking_type ? this.params.booking_type : 2;
        }
    },
    components: { DateRangePicker },
    props:['params', 'auth'],
    methods:{
        updateValues(date){
            this.when.startDate = this.getDate(date.startDate);

        },
        updateToValues(date){
            this.when_to.startDate = this.getDate(date.startDate);

        },
        dateFormat (classes, date) {
            if (!classes.disabled) {
                classes.disabled = date.getTime() < (new Date()).setDate((new Date()).getDate() - 1)
            }
            return classes
        },
        
        submit(){
            let _self = this;
            $('#booking-vue-app .btn-orange').attr('disabled', true);
            if(!this.auth){
                swal({
                    title: this.__('pages.booking_warning_auth'),
                    type: 'warning',
                    timer: 2000,
                    showConfirmButton: false
                });

                return false;
            }
            if(parseInt(this.property_id) <= 0){
                swal({
                    title: this.__('pages.booking_error_property_id'),
                    type: 'error',
                    timer: 2000,
                    showConfirmButton: false
                });

                return false;
            }
            axios.post(Laravel.baseApiUrl + '/booking', {
                when_start: this.when.startDate,
                when_end: this.booking_type == 1 ? this.when.startDate : this.when_to.startDate,
                time_to: this.time_to,
                time_from: this.time_from,
                booking_type: this.booking_type,
                property_id: this.property_id,
                comment: this.comment,
                api_token: Laravel.apiToken,
            })
            .then(function(response){
                _self.comment = '';
                $('.invalid-feedback').addClass('d-none');
                $('#booking-vue-app .btn-orange').removeAttr('disabled');
                swal({
                    title: _self.__('pages.booking_success'),
                    type: 'success',
                    timer: 2000,
                    showConfirmButton: false
                });
            }).catch(function(error){
                $('#booking-vue-app .btn-orange').removeAttr('disabled');
                _self.errorHandler(error.response);
            });
            
        }    
    }
}
</script>